import { Helmet } from "react-helmet-async";

interface SEOProps {
  title: string;
  description: string;
  canonical?: string;
  ogImage?: string;
  type?: string;
  noindex?: boolean;
  schema?: object | object[];
}

const SITE_URL = "https://www.arcondes.com";
const DEFAULT_OG_IMAGE = `${SITE_URL}/og-arcondes.png`;
const SPANISH_SEO_OVERRIDES: Record<string, { title: string; description: string }> = {
  "/": {
    title: "Inspecciones de Edificios, Fachadas y Cumplimiento en NYC",
    description: "Inspecciones FISP/Local Law 11, parapetos, filtraciones, reparaciones estructurales, violaciones DOB e informes de ingenieria en NYC. Evaluacion gratis.",
  },
  "/about/": {
    title: "Sobre ARCONDES - Equipo de Inspeccion e Ingenieria en NYC",
    description: "Ingenieros licenciados e inspectores QEWI con mas de 15 anos de experiencia y 200+ edificios inspeccionados en NYC y Long Island.",
  },
  "/services/": {
    title: "Servicios de Inspeccion e Ingenieria de Edificios en NYC",
    description: "Inspecciones de fachada FISP, filtraciones, reparaciones estructurales, informes de ingenieria, violaciones DOB y consultoria de construccion.",
  },
  "/services/facade-inspection/": {
    title: "Inspeccion de Fachadas NYC - Cumplimiento FISP y Local Law 11",
    description: "Inspecciones de fachada QEWI para edificios de NYC de mas de 6 pisos. Cumplimiento FISP Cycle 10, filing DOB e informes detallados.",
  },
  "/services/parapet-inspection/": {
    title: "Inspeccion de Parapetos y Techos NYC - Cumplimiento Anual",
    description: "Inspecciones profesionales de parapetos y techos en NYC. Evaluaciones anuales, revision estructural, riesgos de filtracion y filing DOB.",
  },
  "/services/leak-investigation/": {
    title: "Investigacion de Filtraciones NYC - Deteccion y Reparacion",
    description: "Investigaciones de filtraciones en edificios de NYC con imagen termica, pruebas de humedad, identificacion de causa y plan de reparacion.",
  },
  "/services/structural-repairs/": {
    title: "Reparaciones Estructurales y Mamposteria NYC",
    description: "Reparaciones estructurales y restauracion de mamposteria en NYC: repointing, concreto, linteles, impermeabilizacion y remediacion SWARMP.",
  },
  "/services/dob-violations/": {
    title: "Resolucion de Violaciones DOB NYC - Cumplimiento y Correccion",
    description: "Resolucion de violaciones DOB en NYC: FISP, multas ECB, certificados de correccion, reparaciones requeridas y presentaciones ante DOB.",
  },
  "/services/engineering-reports/": {
    title: "Informes de Ingenieria NYC - Evaluaciones y Filing DOB",
    description: "Informes profesionales de ingenieria para edificios de NYC: FISP, condiciones, due diligence, planificacion de capital y filing DOB.",
  },
  "/services/construction-consulting/": {
    title: "Consultoria y Contratacion de Construccion NYC",
    description: "Consultoria de construccion, contratacion general, diseno arquitectonico, restauraciones, renovaciones y coordinacion de permisos DOB en NYC.",
  },
  "/services/contract-templates/": {
    title: "Plantillas de Contratos de Construccion para Proyectos en NYC",
    description: "Plantillas editables de contratos de construccion para reparacion de fachadas, FISP y proyectos de envolvente en NYC. Solicite informacion.",
  },
  "/projects/": {
    title: "Proyectos de Inspeccion y Reparacion de Fachadas en NYC",
    description: "Vea proyectos completados de inspeccion de fachadas, reparaciones estructurales e ingenieria en Manhattan, Brooklyn, Queens y Bronx.",
  },
  "/areas-we-serve/": {
    title: "Areas de Servicio - Inspecciones en los 5 Condados de NYC",
    description: "ARCONDES ofrece inspecciones de fachada, reparaciones estructurales, filtraciones e ingenieria en Manhattan, Brooklyn, Queens, Bronx y Staten Island.",
  },
  "/areas/manhattan/": {
    title: "Inspecciones de Edificios y Fachadas en Manhattan",
    description: "Ingenieros licenciados para FISP, fachadas, ingenieria estructural, violaciones DOB y cumplimiento de edificios en Manhattan.",
  },
  "/areas/brooklyn/": {
    title: "Inspecciones de Edificios y Fachadas en Brooklyn",
    description: "Inspecciones FISP, ingenieria estructural, violaciones DOB y cumplimiento para propiedades de Brooklyn, de brownstones a edificios altos.",
  },
  "/areas/queens/": {
    title: "Inspecciones de Edificios y Fachadas en Queens",
    description: "Inspecciones FISP, ingenieria estructural y cumplimiento DOB para edificios en Queens, desde Astoria y LIC hasta Flushing y Jamaica.",
  },
  "/areas/bronx/": {
    title: "Inspecciones de Edificios y Fachadas en Bronx",
    description: "Inspecciones FISP, ingenieria estructural y cumplimiento DOB para edificios del Bronx, desde South Bronx hasta Riverdale.",
  },
  "/areas/staten-island/": {
    title: "Inspecciones de Edificios y Fachadas en Staten Island",
    description: "Inspecciones FISP, ingenieria estructural y cumplimiento DOB para edificios en Staten Island, de St. George a Tottenville.",
  },
  "/contact/": {
    title: "Contacte a ARCONDES - Evaluacion Gratis de Edificios en NYC",
    description: "Solicite una evaluacion gratuita de inspeccion de edificio. Llame al 347-613-1717 o envie el formulario. Servicio en NYC y Long Island.",
  },
  "/building-report/": {
    title: "Reporte Gratis de Cumplimiento de Edificios en NYC",
    description: "Obtenga un reporte gratis de cumplimiento en NYC: violaciones DOB, estado FISP, multas y recomendaciones de expertos.",
  },
  "/blog/local-law-11-facade-inspection-nyc/": {
    title: "Inspeccion de Fachadas Local Law 11 NYC: Guia Completa 2026",
    description: "Guia completa de inspecciones de fachada Local Law 11/FISP en NYC: plazos, costos, requisitos, clasificaciones y multas.",
  },
  "/case-studies/1-university-place/": {
    title: "1 University Place - Caso de Restauracion de Fachada FISP",
    description: "Como ARCONDES llevo un edificio de 12 pisos en Manhattan de SWARMP a Safe con inspeccion FISP, restauracion y cumplimiento DOB.",
  },
  "/case-studies/100-henry-street/": {
    title: "100 Henry Street - Caso de Rehabilitacion de Fachada en Brooklyn",
    description: "Restauracion de fachada en edificio prewar de Brooklyn: investigacion de filtraciones, repointing, impermeabilizacion y violaciones DOB.",
  },
  "/case-studies/765-riverside-drive/": {
    title: "765 Riverside Drive - Caso de Ingenieria Estructural en Manhattan",
    description: "Diseno de refuerzo estructural para equipos mecanicos en azotea: planos PE, filing DOB y supervision de construccion.",
  },
  "/products/": {
    title: "Productos Recomendados para Propietarios de Edificios en NYC",
    description: "Productos profesionales de impermeabilizacion, selladores, reparacion de techos y seguridad recomendados por ARCONDES.",
  },
  "/tools/violation-calculator/": {
    title: "Calculadora de Multas por Violaciones NYC",
    description: "Calculadora gratis para estimar cuanto cuestan ahora las violaciones DOB y ECB de su edificio en NYC.",
  },
};

const normalizePath = (path: string) => {
  if (!path || path === "/") return "/";
  return path.endsWith("/") ? path : `${path}/`;
};

const normalizeUrl = (url: string) => {
  if (!url.startsWith(SITE_URL)) return url;
  const path = url.slice(SITE_URL.length) || "/";
  return `${SITE_URL}${normalizePath(path)}`;
};

const SEO = ({
  title,
  description,
  canonical,
  ogImage = DEFAULT_OG_IMAGE,
  type = "website",
  noindex = false,
  schema,
}: SEOProps) => {
  const rawPathname = typeof window !== 'undefined' ? window.location.pathname : '/';
  const pathname = normalizePath(rawPathname);
  const isSpanishPath = pathname === "/es/" || pathname.startsWith("/es/");
  const languageNeutralPath = isSpanishPath ? normalizePath(pathname.replace(/^\/es/, "") || "/") : pathname;
  const englishUrl = `${SITE_URL}${languageNeutralPath}`;
  const spanishUrl = `${SITE_URL}${normalizePath(`/es${languageNeutralPath === "/" ? "" : languageNeutralPath}`)}`;
  const requestedCanonical = canonical ? normalizeUrl(canonical) : `${SITE_URL}${pathname}`;
  const canonicalPath = requestedCanonical.startsWith(SITE_URL)
    ? normalizePath(requestedCanonical.slice(SITE_URL.length) || "/")
    : "";
  const canonicalUrl = isSpanishPath && canonicalPath && !canonicalPath.startsWith("/es/")
    ? spanishUrl
    : requestedCanonical;
  const localized = isSpanishPath ? SPANISH_SEO_OVERRIDES[languageNeutralPath] : undefined;
  const displayTitle = localized?.title || title;
  const displayDescription = localized?.description || description;
  const fullTitle = displayTitle.includes("ARCONDES") ? displayTitle : `${displayTitle} | ARCONDES`;

  return (
    <Helmet htmlAttributes={{ lang: isSpanishPath ? "es" : "en" }}>
      <title>{fullTitle}</title>
      <meta name="description" content={displayDescription} />
      <link rel="canonical" href={canonicalUrl} />
      <meta name="robots" content={noindex ? "noindex, nofollow" : "index, follow"} />
      {!noindex && <link rel="alternate" hrefLang="en" href={englishUrl} />}
      {!noindex && <link rel="alternate" hrefLang="es" href={spanishUrl} />}
      {!noindex && <link rel="alternate" hrefLang="x-default" href={englishUrl} />}

      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={displayDescription} />
      <meta property="og:type" content={type} />
      <meta property="og:url" content={canonicalUrl} />
      <meta property="og:image" content={ogImage} />
      <meta property="og:site_name" content="ARCONDES" />
      <meta property="og:locale" content={isSpanishPath ? "es_US" : "en_US"} />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={displayDescription} />
      <meta name="twitter:image" content={ogImage} />

      {schema && (
        <script type="application/ld+json">
          {JSON.stringify(Array.isArray(schema) ? schema : schema)}
        </script>
      )}
    </Helmet>
  );
};

export default SEO;
